import React from 'react';
import { Box, Typography, Chip } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import pluralize from 'pluralize';
import { TagItemMenuButton } from '../TagItem/TagItemMenu';
import { AdminConsoleVolunteerTag } from '../__generated__/AdminConsoleVolunteerTag';

const DEFAULT_TAG_COLOUR = '#796fff';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      '&:not(:first-child)': {
        marginTop: '1.25rem',
      },
      paddingTop: '.6rem',
      paddingBottom: '.6rem',
      borderTopColor: '#EFEFEF',
      borderTop: '1px solid',
      paddingRight: '1rem',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headerNameWrapper: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    swatchWrapper: {
      width: '1.125rem',
      height: '1.125rem',
      display: 'flex',
      alignItems: 'center',
      marginRight: '0.5rem',
    },
    swatch: {
      width: 12,
      height: 12,
      borderRadius: '50%',
    },
    description: {
      fontSize: '14px',
      color: '#808080',
    },
    chip: {
      borderRadius: '4px',
      fontSize: '11px',
      fontWeight: 500,
      color: '#333',
      marginRight: '8px',
    },
  })
);

interface Props {
  tag: AdminConsoleVolunteerTag;
  isLoading: boolean;
  onEdit: (tag: AdminConsoleVolunteerTag) => void;
  onDelete: (tag: AdminConsoleVolunteerTag) => void;
}

export function VolunteerTagItem({ tag, onEdit, onDelete, isLoading = false }: Props) {
  const classes = useStyles();
  const { name, description, colour, volunteerCount, isArchived } = tag;

  const onAction = (action: string) => {
    if (action === 'edit') onEdit(tag);
    if (action === 'delete') onDelete(tag);
  };

  const readableCount = pluralize('Volunteer', volunteerCount, true);

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Box className={classes.headerNameWrapper}>
          <Typography style={{ fontWeight: 600, fontSize: '15px', display: 'flex', alignItems: 'center' }}>
            <Box className={classes.swatchWrapper}>
              <Box className={classes.swatch} style={{ backgroundColor: colour || DEFAULT_TAG_COLOUR }} />
            </Box>
            {name}
          </Typography>
        </Box>
        <TagItemMenuButton onAction={onAction} />
      </Box>
      {description && (
        <Typography variant={'body2'} className={classes.description}>
          {description}
        </Typography>
      )}
      <Box paddingTop='20px'>
        {!isLoading && <Chip label={readableCount} className={classes.chip} />}
        {isArchived && (
          <Chip
            label='Archived'
            style={{
              borderRadius: '4px',
              fontSize: '11px',
              fontWeight: 500,
              color: '#333',
              backgroundColor: '#e0e0e0',
            }}
          />
        )}
      </Box>
    </Box>
  );
}
